import moment from 'moment';
import { IBranchesLogFilters } from 'src/view/screens/BranchLogScreen/screens/BranchesLogScreen/types/branchesLog';

export enum BRANCHES_LOG_COLUMN {
  BRANCH = 'branch',
  DATE = 'date',
  OBJECT = 'object',
  AUTHOR = 'author',
  DETAILS = 'details',
}

export const defaultBranchesLogFilters: IBranchesLogFilters = {
  branchIds: undefined,
  sortBy: undefined,
  sortDir: undefined,
  startDate: moment().startOf('month').unix(),
  endDate: moment().unix(),
};
